module.exports = __webpack_public_path__ + "static/media/advertisers_section4.7fcee856.png";